module.exports = __webpack_public_path__ + "static/media/paypal.e2175de9.png";